import { render, staticRenderFns } from "./HistoryListRow.vue?vue&type=template&id=5b40ce27&scoped=true&"
import script from "./HistoryListRow.vue?vue&type=script&lang=ts&"
export * from "./HistoryListRow.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryListRow.vue?vue&type=style&index=0&id=5b40ce27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40ce27",
  null
  
)

export default component.exports